/*eslint no-script-url: 0 */
import React, { Component } from "react";
import developmentImage from '../../assets/images/default.jpg';

export default class ResetImage extends Component {

	constructor(props, context) {
		super(props, context);
		this.resetImage = this.resetImage.bind(this);
	}

	resetImage() {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				uploadedFile: null,
				frameImage: developmentImage,
				frameImageHeight: 40,
				frameImageWidth: 60,
				aspectRatio: 1.5,
			}
		})
	}

 	render() {
	    return (
	    	<li className="m-b-5">
				<a href="#!" onClick={this.resetImage} className="btn btn-danger text-upper">Reset Image</a>
			</li>
	    );
  	}
}